import React from "react";
import { Card } from "react-bootstrap";

/**
 * ENERGO Card
 * 
 * @param {props} icon html icon
 * @param {props} title string title of card
 * @param {props} children html elements
 * 
 * @returns card
 */
const EnergoCard = ({ icon, title, children }) => {
    return (
        <Card className="card-energo shadow-lg">
            <Card.Body style={{padding: 0}} className="text-start">
                <div className="card-energo-header">
                    <p className="text-light">
                        {icon}
                        &nbsp; {title}
                    </p>
                </div>
                <div className="card-energo-children">
                    {children}
                </div>
                <div className="card-energo-footer"></div>
            </Card.Body>
        </Card>
    );
};
export default EnergoCard;
